/**
 * Extracts the BE-provided detail message from a failed GUS/company-data-search
 * lookup (app.invoices.companyData), e.g.:
 * { type: "validation_error", errors: [{ code, detail, attr: "nip" }] }
 *
 * Falls back to fallbackMessage when the error has no such shape
 * (e.g. a network error with no response).
 *
 * @param {*} error - NetworkError (or plain Error) thrown by ApiClientAsync
 * @param {string} fallbackMessage
 * @returns {string}
 */
export function getCompanyDataSearchErrorMessage(error, fallbackMessage) {
  const errors = error?.response?.data?.errors;
  const detail = Array.isArray(errors)
    ? errors.find(item => item?.detail)?.detail
    : undefined;

  return detail ?? fallbackMessage;
}
